import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

// local components
import ApiUrl from '../../../components/ApiUrl/ApiUrlInfo'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import EditableHOCWrapper from '../../HOC/EditableHOC'
import { openErrorMessage, openSuccessMessage } from '../../../actions/message'
import { getApiUrl } from '../../../utils/common'

const defaultApiUrl = getApiUrl()
const ApiUrlEditable = EditableHOCWrapper(ApiUrl)

class ApiUrlContainer extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      apiUrl: defaultApiUrl,
    }
  }

  componentDidMount() {}

  onSave = () => {
    if (this.isUrlValid()) {
      window.localStorage.setItem('apiUrl', this.state.apiUrl)
      this.props.dispatch(openSuccessMessage('API URL Updated'))
      window.location.reload()
    } else {
      this.props.dispatch(openErrorMessage('Enter a valid API URL'))
    }
  }

  isUrlValid = () => {
    const url = this.state.apiUrl
    if (!url) return false
    if (!url.endsWith('blaze.me/')) {
      return false
    }
    return true
  }

  onCancel = () => {
    const url = getApiUrl()
    this.setState({
      apiUrl: url,
    })
  }

  updateApiUrl = (e) => {
    const { value } = e.target
    this.setState({
      apiUrl: value,
    })
  }

  onClear = () => {
    window.localStorage.removeItem('apiUrl')
    const url = getApiUrl()
    this.setState({
      apiUrl: url,
    })
    window.location.reload()
  }

  render() {
    return (
      <ApiUrlEditable
        onSave={this.onSave}
        onCancel={this.onCancel}
        apiUrl={this.state.apiUrl}
        updateApiUrl={this.updateApiUrl}
        onClear={this.onClear}
      />
    )
  }
}

const ApiUrlWithTitle = ContainerWithTitle(ApiUrlContainer, 'API URL')
const ApiUrlConnected = connect(({ dispatch }) => ({ dispatch }))(ApiUrlWithTitle)

export default ApiUrlConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/ApiUrl.js